import React from 'react';
import { Routes, Route } from 'react-router-dom';
import CarLayout from './Layout/carLayout';
import { Login } from './page/login/login'
import { Register } from './page/register/register'
import { Forgot } from './page/forgot/forgot'
import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <Routes>
      <Route path='/*' element={<CarLayout />}></Route>
      <Route path='login' element={<Login />}></Route>
      <Route path='register' element={<Register />}></Route>
      <Route path='forgot' element={<Forgot />}></Route>
    </Routes>
  );
}

export default App;
